module.exports = __webpack_public_path__ + "static/media/gssoc.58c89d0c.png";